import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f8dd314"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border-group" }
const _hoisted_2 = {
  key: 0,
  class: "row g-2 mb-3"
}
const _hoisted_3 = { class: "side-panel h-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BorderSideDetail = _resolveComponent("BorderSideDetail")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_MetadataGroupCard = _resolveComponent("MetadataGroupCard")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createVNode(_component_MetadataGroupCard, {
        title: _ctx.$t('cms.border'),
        enabled: _ctx.enabled,
        name: _ctx.$t('cms.border'),
        errors: _ctx.errors,
        "onUpdate:enabled": _ctx.onEnabledChanged,
        onReset: _ctx.resetToPersisted
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_BorderSideDetail, {
              modelValue: _ctx.sharedSide,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sharedSide) = $event)),
                _ctx.onSharedSideChanged
              ],
              name: _ctx.$t('cms.border'),
              errors: _ctx.errors,
              disabled: _ctx.useIndividualSides
            }, null, 8, ["modelValue", "name", "errors", "disabled", "onUpdate:modelValue"]),
            _createVNode(_component_InputCheckboxBoolean, {
              modelValue: _ctx.useIndividualSides,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.useIndividualSides) = $event)),
                _ctx.onUseIndividualSidesChanged
              ],
              label: _ctx.$t('cms.borderIndividualSides'),
              name: `${_ctx.$t('cms.border')} ${_ctx.$t('cms.borderIndividualSides')}`,
              errors: _ctx.errors,
              "checkbox-look": "",
              class: "mb-3"
            }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]),
            (_ctx.useIndividualSides)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sides, (side) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: side.key,
                      class: "col-3"
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_BorderSideDetail, {
                          modelValue: _ctx.localDto[side.key],
                          "onUpdate:modelValue": [($event: any) => ((_ctx.localDto[side.key]) = $event), _ctx.emitModelChanged],
                          label: side.label,
                          name: `${_ctx.$t('cms.border')} ${side.label}`,
                          errors: _ctx.errors,
                          compact: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "errors"])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["title", "enabled", "name", "errors", "onUpdate:enabled", "onReset"])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}